import React, { useMemo } from "react";
import useAuth from "../../hooks/useAuth";
import SidebarItem from "./SidebarItem";
import { staticMenuSeed } from "../../utils/staticMenuSeed";
import "./sidebar.css";

function normalizeMenus(items = []) {
  return items
    .filter((item) => item?.name)
    .map((item) => ({
      ...item,
      route_path: item?.route_path || item?.path || null,
      children: normalizeMenus(item?.children || item?.menus || []),
    }));
}

export default function DynamicSidebar() {
  const auth = useAuth() || {};
  const remoteMenus = Array.isArray(auth.menus) ? auth.menus : [];

  const menus = useMemo(() => {
    const normalized = normalizeMenus(remoteMenus);
    return normalized.length > 0 ? normalized : staticMenuSeed;
  }, [remoteMenus]);

  return (
    <aside className="payroll-sidebar">
      <div className="payroll-sidebar__brand-wrap">
        <div className="payroll-sidebar__brand">
          <div className="payroll-sidebar__brand-icon">EP</div>
          <div className="payroll-sidebar__brand-copy">
            <h2>Payroll Admin</h2>
            <p>Enterprise Workspace</p>
          </div>
        </div>
      </div>

      <div className="payroll-sidebar__section-label">Navigation</div>

      <nav className="payroll-sidebar__nav">
        {menus.map((menu, index) => (
          <SidebarItem key={menu?.code || menu?.id || menu?.route_path || index} item={menu} />
        ))}
      </nav>
    </aside>
  );
}
